// extracted by mini-css-extract-plugin
export var section = "resellersWhyXeal-module--section--6250f";